import React, { FC } from 'react';

interface TitleType {
    title: string;
}

const Title: FC<TitleType> = ({ title }) => {
    return (
        <div className="title flex align-center">
            <h3>{title}</h3>
        </div>
    );
};

export default Title;
